<template>
  <div
    class="flex flex-col bg-gray-100 p-6 min-h-screen mt-0 sm:mt-0 md:mt-0 lg:mt-2 xl:mt-2"
  >
    <div>
      <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
        Taken
      </p>
    </div>

    <div class="flex flex-row">
      <div class="self-end"></div>
      <div class="flex-grow"></div>
    </div>
    <div class="flex flex-row">
      <div class="flex-grow"></div>
    </div>

    <div
      v-if="todoitems"
      class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 grid-flow-row gap-4"
    >
      <div
        v-for="item in todoitems"
        :key="item.uuid"
        @click="openTodo(item.uuid)"
        class="bg-gray-200 hover:bg-opacity-25 font-opensans rounded-lg shadow-lg hover:shadow-xl cursor-pointer"
      >
        <div
          class="py-2 px-2 text-center font-bold uppercase tracking-wide rounded-t-lg text-gray-100 truncate"
          :class="{
            'bg-mi-blue-500': !isOverdue(item),
            'bg-red-600': isOverdue(item)
          }"
        >
          {{ item.title }}
        </div>
        <p class="font-opensans mt-4 mx-2 text-sm truncate capitalize">
          {{ item.accommodatie_naam }} ({{ item.object_name }})
        </p>
        <p
          class="font-opensans mt-2 mx-2 text-sm truncate "
          :class="{ 'text-red-600': isOverdue(item) }"
        >
          {{ getDeadline(item.deadline) }}
        </p>
        <p
          class="font-opensans my-2 mx-2 text-sm truncate"
          v-if="
            (item.actor_uuid == user_uuid) | (item.creator_uuid == user_uuid)
          "
        >
          Rollen:
          {{ item.actor_uuid == user_uuid ? "uitvoerder" : "" }}
          {{ item.creator_uuid == user_uuid ? "aanmaker" : "" }}
        </p>
      </div>
    </div>
    <div
      v-else
      class="flex m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 p-3"
    >
      <div class="m-auto">
        <img src="../../assets/logo.svg" class="w-64 pl-8 mt-32" />
      </div>
    </div>

    <Pagination />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Pagination from "./Pagination";

export default {
  created: function() {
    this.searchForTodoItems();
  },
  computed: {
    todoitems: function() {
      return this.$store.state.backend_data.todolist;
    },
    user_uuid: function() {
      return this.$store.state.user.id;
    }
  },
  methods: {
    ...mapActions(["searchForTodoItems"]),
    isOverdue: function(item) {
      if ((item.deadline === null) | (item.finished !== null)) return false;
      const deadline_date = new Date(item.deadline);
      return deadline_date < new Date();
    },
    getDeadline: function(deadline) {
      if (deadline === null) return "Geen deadline";
      const datum = new Date(deadline);
      return `Deadline: ${datum.getDate()}-${datum.getMonth() +
        1}-${datum.getFullYear()}`;
    },
    openTodo: function(uuid) {
      // get to do item
      // determine route from there
      const todoitem = this.todoitems.find(item => item.uuid === uuid);
      const name =
        todoitem.object_name == "accommodatie" ? "Accommodatie" : "Voorziening";
      const params =
        todoitem.object_name == "accommodatie"
          ? { id: todoitem.accommodatie_uuid }
          : { id: todoitem.accommodatie_uuid, vzid: todoitem.object_uuid };
      const hash = `#${todoitem.uuid}`;

      this.$router.push({
        name,
        params,
        hash
      });
    }
  },

  components: {
    Pagination
  }
};
</script>
